var _line, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _line2, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTabletAiPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 704,
  height: 826,
  viewBox: "0 0 704 826",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 704,
  y1: 0.500488,
  x2: -4.37113e-8,
  y2: 0.500427,
  stroke: "black"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 16.0005,
  width: 268,
  height: 23,
  fill: "#E5E5E5"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  y: 63.0005,
  width: 230,
  height: 18,
  fill: "#E5E5E5"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  y: 89.0005,
  width: 460,
  height: 62,
  fill: "#E5E5E5"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  y: 159,
  width: 460,
  height: 40,
  fill: "#E5E5E5"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  y: 211,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  y: 245,
  width: 460,
  height: 379,
  fill: "#E5E5E5"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 460,
  y1: 644.5,
  x2: -4.37114e-8,
  y2: 644.5,
  stroke: "#E5E5E5"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  y: 664,
  width: 230,
  height: 18,
  fill: "#E5E5E5"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  y: 690,
  width: 460,
  height: 62,
  fill: "#E5E5E5"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  y: 760,
  width: 460,
  height: 40,
  fill: "#E5E5E5"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  y: 812,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 492,
  y: 63.0005,
  width: 100,
  height: 18,
  fill: "#E5E5E5"
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  x: 492,
  y: 93.0005,
  width: 212,
  height: 62,
  fill: "#E5E5E5"
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  x: 492,
  y: 167,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  x: 492,
  y: 201,
  width: 100,
  height: 18,
  fill: "#E5E5E5"
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  x: 492,
  y: 231,
  width: 212,
  height: 62,
  fill: "#E5E5E5"
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  x: 492,
  y: 305,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
})), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  x: 492,
  y: 339,
  width: 100,
  height: 18,
  fill: "#E5E5E5"
})), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
  x: 492,
  y: 369,
  width: 212,
  height: 62,
  fill: "#E5E5E5"
})), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
  x: 492,
  y: 443,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
})), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
  x: 492,
  y: 477,
  width: 100,
  height: 18,
  fill: "#E5E5E5"
})), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
  x: 492,
  y: 507,
  width: 212,
  height: 62,
  fill: "#E5E5E5"
})), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
  x: 492,
  y: 581,
  width: 200,
  height: 14,
  fill: "#E5E5E5"
})));
export default SvgTabletAiPlaceholder;